import { useLayoutEffect, useState } from 'react';

/**
 * Largura do elemento, medida antes da pintura e atualizada quando ele muda
 * de tamanho. Os gráficos recebem a largura pronta (em vez do
 * ResponsiveContainer), então já nascem desenhados, inclusive no PDF.
 *
 * Devolve `[ref, width]`; `ref` é uma ref de callback (mede também quando o
 * elemento só aparece depois do primeiro render).
 */
export default function useElementWidth() {
  const [element, setElement] = useState(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!element) return undefined;
    setWidth(Math.floor(element.getBoundingClientRect().width));
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry]) => setWidth(Math.floor(entry.contentRect.width)));
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return [setElement, width];
}
